/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '~/common/types/graphql.ts';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type GeoItemSearchAreaInput = {
  geometry: Types.JsonObject;
  mode: GeoItemSearchAreaMode;
};

export type GeoItemSearchAreaMode =
  | 'contains'
  | 'covers'
  | 'intersects'
  | 'within';

export type GeoItemSearchInput = {
  area?: GeoItemSearchAreaInput | null | undefined;
  label?: string | null | undefined;
  limit?: number | null | undefined;
  offset?: number | null | undefined;
  statuses?: Array<GeoItemSearchStatus> | null | undefined;
  tenantId: string;
};

export type GeoItemSearchStatus =
  | 'deactivated'
  | 'draft'
  | 'init'
  | 'published';

export type SearchGeoItemsForListQueryVariables = Exact<{
  input: Types.GeoItemSearchInput;
}>;


export type SearchGeoItemsForListQuery = { cnutSearchGeoItems: { __typename: 'GeoItemSearchOutput', total: number, items: Array<{ __typename: 'GeoItemSearchItemOutput', id: string, fromJdn: number | null, toJdn: number | null, i18nLabel: Types.JsonObject, recordGeoItems: Array<{ __typename: 'GeoItemSearchRecordGeoItemOutput', record: { __typename: 'GeoItemSearchRecordOutput', id: string, name: string | null } }> }> } };


export const SearchGeoItemsForListDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchGeoItemsForList"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GeoItemSearchInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cnutSearchGeoItems"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"fromJdn"}},{"kind":"Field","name":{"kind":"Name","value":"toJdn"}},{"kind":"Field","name":{"kind":"Name","value":"i18nLabel"}},{"kind":"Field","name":{"kind":"Name","value":"recordGeoItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"record"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}}]}}]} as unknown as DocumentNode<SearchGeoItemsForListQuery, SearchGeoItemsForListQueryVariables>;